import { useState, useEffect } from 'react'
import { DataStore } from 'aws-amplify'
import { Reports } from 'models'

/*
 * Observable for the Reports table.
 */
export function observeReports() {
  const [reports, setReports] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const retrieveData = async () => {
      const reports = await DataStore.query(Reports, null)
      setReports(reports.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()))
      setIsLoaded(true)
    }

    const subscription = DataStore.observe(Reports).subscribe(retrieveData)
    retrieveData()

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return { reports, isLoaded }
}

export default observeReports
